import * as tslib_1 from "tslib";
import { EventEmitter } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { TranslateService } from "@ngx-translate/core";
import { AppComponent } from "../../app.component";
import { Router } from "@angular/router";
import { PhotosphereManager } from "../../../business/managers/photosphere.manager";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
import { FormInfo } from "../../../crossconcern/models/form/forminfo";
import { FormInfoField } from "../../../crossconcern/models/form/forminfofield";
import { FORM_TYPE_SELECT, FORM_WIDTH_COL_12, FORM_WIDTH_OFFSET_COL_0 } from "../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import { MeasureInfoModel } from "../../../datastore/entities/measureinfo.model";
var PolygonEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PolygonEditorComponent, _super);
    function PolygonEditorComponent(translate, appComponent, router, photosphereManager, location, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.translate = translate;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.photosphereManager = photosphereManager;
        _this.location = location;
        _this.alertUtils = alertUtils;
        _this.save = new EventEmitter();
        _this.delete = new EventEmitter();
        _this.productValues = [];
        _this.productMeasuresDropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "customText",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        return _this;
    }
    PolygonEditorComponent.prototype.ngOnChanges = function () {
        var _this = this;
        this.productValues = [];
        if (this.products) {
            var language = this.photosphereManager.getCurrentLanguage();
            for (var _i = 0, _a = this.products; _i < _a.length; _i++) {
                var prod = _a[_i];
                this.productValues.push({
                    id: prod.uuid,
                    text: this.getProductName(prod, language)
                });
            }
        }
        var formInfoFields = [
            new FormInfoField(FORM_TYPE_SELECT, "POLYGON_EDITOR_COMPONENT_PRODUCT", "product", [
                Validators.required
            ], null, this.productValues, this.selectedProduct, true, false, null, FORM_WIDTH_COL_12, FORM_WIDTH_OFFSET_COL_0, null, function () { return _this.onProductSelect(); })
        ];
        this.formInfo = new FormInfo(formInfoFields, null);
        setTimeout(function () {
            _this.formComponent.updateFormValues(_this.formInfo);
            if (_this.selectedProduct) {
                _this.onProductSelect(true);
            }
        });
    };
    PolygonEditorComponent.prototype.onSave = function () {
        var _this = this;
        this.save.emit({
            product: this.formComponent.form.value.product,
            productInfo: (this.selectedProductMeasure && this.selectedProductMeasure[0] !== undefined)
                ? JSON.stringify(this.selectedProductMeasures.filter(function (measure) {
                    var found = false;
                    _this.selectedProductMeasure.forEach(function (element) {
                        found = found === false ? measure.id === element.id : found;
                    });
                    return found;
                })) : JSON.stringify({})
        });
    };
    PolygonEditorComponent.prototype.onDelete = function () {
        this.delete.emit();
    };
    PolygonEditorComponent.prototype.onProductSelect = function (fromInit) {
        var _this = this;
        this.selectedProductMeasures = null;
        this.selectedProductMeasure = null;
        var formProductUuid = this.formComponent.form.value.product;
        if (formProductUuid) {
            var selectedProduct = this.products.find(function (item) { return item.uuid === formProductUuid; });
            this.photosphereManager.getProductInfo(selectedProduct.speCod, selectedProduct.varCod)
                .subscribe(function (productInfo) {
                _this.handleProductMeasures(productInfo);
                if (fromInit) {
                    if (_this.selectedProductInfo) {
                        var measures = JSON.parse(_this.selectedProductInfo);
                        var measureModels = [];
                        if (measures.length !== undefined && measures.length > 0) {
                            measureModels = measures.map(function (element) { return new MeasureInfoModel(element); });
                        }
                        _this.checkSelectedProductMeasure(measureModels);
                    }
                }
            });
        }
    };
    PolygonEditorComponent.prototype.handleProductMeasures = function (productInfo) {
        var _this = this;
        this.selectedProductMeasures = productInfo.measures.map(function (measure, index) {
            measure.id = index;
            return _this.handleProductMeasuresDesc(measure);
        });
    };
    PolygonEditorComponent.prototype.handleProductMeasuresDesc = function (measure) {
        var customText = "";
        customText = customText + this.handleProductMeasureDesc(measure.altCod, measure.altDex, "PRODUCT_DETAIL_MEASURE_ALT");
        customText = customText + this.handleProductMeasureDesc(measure.cirCod, measure.cirDex, "PRODUCT_DETAIL_MEASURE_CIR");
        customText = customText + this.handleProductMeasureDesc(measure.cndCod, measure.cndDex, "PRODUCT_DETAIL_MEASURE_CND");
        customText = customText + this.handleProductMeasureDesc(measure.mcoCod, measure.mcoDex, "PRODUCT_DETAIL_MEASURE_MCO");
        customText = customText + this.handleProductMeasureDesc(measure.tipCod, measure.tipDex, "PRODUCT_DETAIL_MEASURE_TIP");
        measure.customText = customText;
        return measure;
    };
    PolygonEditorComponent.prototype.handleProductMeasureDesc = function (measureFeatureCod, measureFeatureDex, measureLabel) {
        var text = "";
        if (measureFeatureCod !== undefined && measureFeatureCod !== null && measureFeatureCod !== "" &&
            measureFeatureDex !== undefined && measureFeatureDex !== null && measureFeatureDex !== "") {
            var translatedLabel = this.translate.instant(measureLabel);
            text = translatedLabel + ": " + measureFeatureDex + " ";
        }
        return text;
    };
    PolygonEditorComponent.prototype.checkSelectedProductMeasure = function (productMeasures) {
        this.selectedProductMeasure = this.selectedProductMeasures.filter(function (measure) {
            var found = false;
            productMeasures.forEach(function (element) {
                found = found === false ? measure.tipCod === element.tipCod &&
                    measure.tipDex === element.tipDex &&
                    measure.cndCod === element.cndCod &&
                    measure.cndDex === element.cndDex &&
                    measure.mcoCod === element.mcoCod &&
                    measure.mcoDex === element.mcoDex &&
                    measure.altCod === element.altCod &&
                    measure.altDex === element.altDex &&
                    measure.cirCod === element.cirCod &&
                    measure.cirDex === element.cirDex : found;
            });
            return found;
        });
    };
    return PolygonEditorComponent;
}(BaseComponent));
export { PolygonEditorComponent };
